import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';

import { AlertDialogComponent } from './alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { MessageDialogComponent } from './message-dialog.component';
import { CopyDialogComponent } from './copy-dialog.component';
import { VersionExpiredDialogComponent } from './version-expired-dialog.component';

@NgModule({
   declarations: [
      AlertDialogComponent,
      ConfirmDialogComponent,
      MessageDialogComponent,
      CopyDialogComponent,
      VersionExpiredDialogComponent,
   ],
   imports: [
      CommonModule,
      MaterialsModule
   ],
   exports: [
      AlertDialogComponent,
      ConfirmDialogComponent,
      MessageDialogComponent,
      CopyDialogComponent,
      VersionExpiredDialogComponent,
   ],
})
export class DialogsModule { }
